(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('subscribeForm', subscribeForm);

    /* @ngInject */
    function subscribeForm() {
        var directive = {
            bindToController: true,
            templateUrl: 'subscribe-form.tpl',
            controller: subscribeFormController,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            scope: {
            }
        };
        return directive;

        function link(scope, element, attrs) {
            // scope.vm.auth = {};
            // scope.vm.errors = 0;
            // var lum = scope.$root.globals.site_options.luminate;
            // scope.vm.settings = {
            //     api_key: lum.api_key,
            //     site_url: {
            //         http: '',
            //         https: lum.secure_url
            //     },
            //     survey_id: parseInt(lum.subscribe_survey_id),
            //     version: '1.0'
            // };
            // scope.vm.site_url = scope.vm.settings.site_url[window.location.protocol.slice(0, -1)];
        }

    }
    /* @ngInject */
    function subscribeFormController ($scope) {

    }
})();